import { createContext, useContext } from 'react';

const TemplatePageContext = createContext();

export const TemplatePageContentProvider = ({ children, page_content, page }) => {

    const meta = page_content.meta ?? null;
    const template_page_content = Object.fromEntries(
        Object.entries(page_content || {}).filter(([key]) => key !== "meta")
    );

    return (
        <TemplatePageContext.Provider value={{ template_page_content: template_page_content, meta: meta, page }}>
            {children}
        </TemplatePageContext.Provider>
    );
}

export const useTemplatePageContent = () => {
    const context = useContext(TemplatePageContext);
    if (context === undefined) {
        throw new Error("useTemplatePageContent must be used within a TemplatePageContentProvider");
    }
    return context;
};
